<sc-modal>
  <div class="flex justify-between mb-6">
    <h3 class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline">
      {{ 'components.unblockSimcardConfirm.title' | scTranslate | async }}
    </h3>
    <sc-button variant="icon" [padding]="false" (click)="close()">
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <div class="font-semibold mb-1">
    {{ 'components.unblockSimcardConfirm.subTitle' | scTranslate | async }}
  </div>
  <p class="mb-6">{{ 'components.unblockSimcardConfirm.text' | scTranslate | async }}</p>
  <p class="text-secondaryText mb-6">
    {{ 'components.unblockSimcardConfirm.additionalInfo' | scTranslate | async }}
  </p>
  <sc-modal-footer>
    <div class="flex justify-between">
      <sc-button variant="alternate" (click)="close(false)">
        <span>
          {{ 'components.unblockSimcardConfirm.secondaryButton' | scTranslate | async }}
        </span>
      </sc-button>
      <sc-button variant="primary" (click)="close(true)">
        <span>
          {{ 'components.unblockSimcardConfirm.primaryButton' | scTranslate | async }}
        </span>
      </sc-button>
    </div>
  </sc-modal-footer>
</sc-modal>
